/**
 * 登录模块
 */
let ucenterUI = null
export const showLoginBox = ({
  type
}) => {
  type = type || ''
  const init = () => {
    if (!ucenterUI) {
      ucenterUI = new Jin10Login() // eslint-disable-line no-undef
    }
    ucenterUI.on(type)
  }
  init()
}

export const getUser = (params) => {
  if (!ucenterUI) {
    ucenterUI = new Jin10Login() // eslint-disable-line no-undef
  }
  return new Promise((resolve, reject) => {
    ucenterUI.getUser(params)
      .then(user => {
        resolve(user)
      })
      .catch(err => {
        reject(err)
      })
  })
}
